import { Facebook, LinkedIn, X } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link } from 'react-router-dom';

import { useFooterStyles } from './styles/footerStyles';

const Footer: React.FC = () => {
  const styles = useFooterStyles();

  return (
    <footer className={styles.footer} data-testid="footer">
      <Grid container spacing={4}>
        {/* Quick Links Section */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography className={styles.sectionTitle} variant="h6">
            Quick Links
          </Typography>
          <Link to="/" className={styles.link}>
            Home
          </Link>
          <Link to="/Services" className={styles.link}>
            Services
          </Link>
          <Link to="/about" className={styles.link}>
            About Us
          </Link>
          <Link to="/contact" className={styles.link}>
            Contact
          </Link>
        </Grid>
        {/* Contact Us Section */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography className={styles.sectionTitle} variant="h6">
            Contact Us
          </Typography>
          <Typography className={styles.contactText}>
            Email:{' '}
            <a href="mailto:Support@DosApes.com" className={styles.link}>
              Support@DosApes.com
            </a>
          </Typography>
          <Typography className={styles.contactText}>Phone: +1 720 530 0012</Typography>
        </Grid>
        {/* Follow Us Section */}{' '}
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography className={styles.sectionTitle} variant="h6">
            Follow Us
          </Typography>
          <Box className={styles.socialIconsContainer}>
            <IconButton
              aria-label="Facebook"
              href="https://facebook.com"
              rel="noopener noreferrer"
              target="_blank"
              className={styles.socialIcon}
            >
              <Facebook />
            </IconButton>
            <IconButton
              aria-label="X"
              href="https://x.com"
              rel="noopener noreferrer"
              target="_blank"
              className={styles.socialIcon}
            >
              <X />
            </IconButton>
            <IconButton
              aria-label="LinkedIn"
              href="https://linkedin.com"
              rel="noopener noreferrer"
              target="_blank"
              className={styles.socialIcon}
            >
              <LinkedIn />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
